import axios from 'axios'
import Credentials from './Credentials'
import CurrentUser from './CurrentUser'

const DEV_KIT_CAR_ID = 1664580408//1664580408

const HOST = 'https://prerelease.moqo.de'
//const HOST = 'http://l:3000'

export default {

  verifyApiToken(apiToken, callback) {
    axios.get(`${HOST}/api/account`, {
      headers: {
        'Authorization': apiToken
      },
      mode: 'no-cors'
    }).then((response)=>{
      Credentials.set(apiToken)
      CurrentUser.set(response.data)
      callback(true)
    }).catch(()=>{
      callback(false)
    })
  },


  fetch(options, callback) {
    let url = `${HOST}/pl/0/platform_admin/cars/${DEV_KIT_CAR_ID}/car_snapshots.json`

    let params = {
      'filter[from]': options.from,
      'filter[until]': options.until,
      'filter[include_car_snapshots]': true,
      'filter[include_drivers_logs]': false,
      'filter[include_bookings]': false
    }

    return axios.get(url, {
      params: params,
      headers: {
        'Authorization': Credentials.get()
      }
    }).then((response)=>{
      let snapshots = response.data.car_snapshots
      if (options.filter) {
        snapshots = snapshots.filter((carSnapshot)=>{
          return !!carSnapshot.card_reader_read_rfid_tags && carSnapshot.card_reader_read_rfid_tags.length > 2
        })
      }
      callback(snapshots)
    })
  }

}

